@if (ad$ | async; as shopAd) {
  @if (adLinkState$ | async; as linkState) {
    @if (linkState.absoluteUrl) {
      <a [href]="linkState.absoluteUrl" [target]="linkState.newTab ? '_blank' : '_self'">
        <ng-container
          *ngTemplateOutlet="AD_TEMPLATE; context: { $implicit: shopAd }"
        ></ng-container>
      </a>
    } @else if (linkState.relativeUrl) {
      <a
        [routerLink]="linkState.relativeUrl"
        [queryParams]="linkState.queryParams"
        queryParamsHandling="merge"
      >
        <ng-container
          *ngTemplateOutlet="AD_TEMPLATE; context: { $implicit: shopAd }"
        ></ng-container>
      </a>
    } @else {
      <ng-container *ngTemplateOutlet="AD_TEMPLATE; context: { $implicit: shopAd }"></ng-container>
    }
  }
}

<ng-template #AD_TEMPLATE let-ad>
  @switch (getMediaType(ad)) {
    @case ('image') {
      <x-ad-picture [media]="ad.media"></x-ad-picture>
    }

    @case ('video') {
      <x-ad-video [media]="ad.media"></x-ad-video>
    }
  }
</ng-template>
